/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Lean_Plum_Rat_CurlInputs */

const en_lean_plum_rat_curl = /** @type {(inputs: Lean_Plum_Rat_CurlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The user has data access to the following segments`)
};

const de_lean_plum_rat_curl = /** @type {(inputs: Lean_Plum_Rat_CurlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Der Nutzer hat Datenzugriff auf die folgenden Segmente`)
};

/**
* | output |
* | --- |
* | "The user has data access to the following segments" |
*
* @param {Lean_Plum_Rat_CurlInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const lean_plum_rat_curl = /** @type {((inputs?: Lean_Plum_Rat_CurlInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Lean_Plum_Rat_CurlInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_lean_plum_rat_curl(inputs)
	return de_lean_plum_rat_curl(inputs)
});